import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import './style.scss';
import Box from '@mui/material/Box';
import ListButton from 'component/ListButton';
import statsEmitter from 'store/modules/connection-indicator/statsEmitter';
import withBoundary from 'component/ErrorBoundary/withBoundary';
const CONNECTION_QUALITY = ['Low', 'Medium', 'Good'];
import { CloseIcon, DownArrowIcon, UpArrowIcon } from 'assets/images';
import { connect } from 'store/modules/base/redux/functions';
import { getLocalParticipant } from 'store/modules/base/participants/functions';
import { getTrackByMediaTypeAndParticipant } from 'store/modules/base/tracks/functions';
import { MEDIA_TYPE } from 'store/modules/base/media/constants';
import { translate } from 'store/modules/base/i18n/functions';

class SystemInformation extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      stats: {}
    };
    this._onStatsUpdated = this._onStatsUpdated.bind(this);
  }

  componentDidMount() {
    // this._onStatsUpdated();
    // this.timeout = setInterval(() => {
    //   this._onStatsUpdated();
    // }, 10000);
    statsEmitter.subscribeToClientStats(
      this.props._participantID,
      this._onStatsUpdated
    );
  }

  /**
   * Updates which user's stats are being listened to.
   *
   * @inheritdoc
   * returns {void}
   */
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps) {
    if (prevProps._participantID !== this.props._participantID) {
      statsEmitter.unsubscribeToClientStats(
        prevProps._participantID,
        this._onStatsUpdated
      );
      statsEmitter.subscribeToClientStats(
        this.props._participantID,
        this._onStatsUpdated
      );
    }
  }

  componentWillUnmount() {
    // if (this.timeout) clearInterval(this.timeout);
    statsEmitter.unsubscribeToClientStats(
      this.props._participantID,
      this._onStatsUpdated
    );
  }

  /**
   * Callback invoked when new connection stats associated with the passed in
   * user ID are available. Will update the component's display of current
   * statistics.
   *
   * @param {Object} stats - Connection stats from the library.
   * @private
   * @returns {void}
   */
  _onStatsUpdated(stats = {}) {
    const { connectionQuality } = stats;
    const newPercentageState =
      typeof connectionQuality === 'undefined'
        ? {}
        : { percent: connectionQuality };
    const newStats = Object.assign(
      {},
      this.state.stats,
      stats,
      newPercentageState
    );

    this.setState({
      stats: newStats
    });
  }

  // eslint-disable-next-line no-unused-vars
  // _buildState(stats) {
  //   const room = this.props._conference;

  //   if (room) {
  //     const PP = String(room.myUserId());
  //     const conn = room.connectionQuality._localStats;
  //     const Quality = room.connectionQuality._calculateConnectionQuality();

  //     let qual = 'Good';

  //     if (Quality > 80) {
  //       qual = 'Good';
  //     } else if (Quality >= 50) {
  //       qual = 'Moderate';
  //     } else if (Quality >= 30) {
  //       qual = 'Weak';
  //     } else {
  //       qual = 'Poor';
  //     }
  //     let p2p = room.isP2PActive();

  //     if (p2p) {
  //       p2p = 'true';
  //     } else {
  //       p2p = 'false';
  //     }
  //     let videoCodec = '';
  //     let audioCodec = '';
  //     let downloadBitrate = '';
  //     let uploadBitrate = '';
  //     let downloadPacketLost = '';
  //     let uploadPacketLost = '';
  //     let resolution = 'N/A';
  //     let bridgeCount = '';
  //     let serverRegion = '';
  //     let bandwidthDownload = 'N/A';
  //     let bandwidthUpload = 'N/A';
  //     let local_address = 'N/A';
  //     let remote_address = 'N/A';
  //     let transport = 'N/A';
  //     let frame = 'N/A';
  //     let reso_height = 'N/A';
  //     let reso_width = 'N/A';

  //     if (conn.codec !== undefined) {
  //       const myID = room.myUserId();
  //       const data = conn.codec[myID];

  //       for (const propName in data) {
  //         // eslint-disable-next-line no-prototype-builtins
  //         if (data.hasOwnProperty(propName)) {
  //           const propValue = data[propName];

  //           videoCodec = propValue.video;
  //           audioCodec = propValue.audio;
  //         }
  //       }
  //     }
  //     if (conn.bridgeCount >= 1) {
  //       if (conn.bitrate !== null && conn.bitrate !== undefined) {
  //         uploadBitrate = conn.bitrate.upload;
  //         downloadBitrate = conn.bitrate.download;
  //       }
  //       if (conn.packetLoss !== null && conn.packetLoss !== undefined) {
  //         downloadPacketLost = conn.packetLoss.total;
  //         uploadPacketLost = conn.packetLoss.upload;
  //       }

  //       // resolution = conn.resolution
  //       // eslint-disable-next-line no-negated-condition
  //       if (conn.bridgeCount !== undefined) {
  //         bridgeCount = conn.bridgeCount;
  //       } else {
  //         bridgeCount = 'N/A';
  //       }
  //       // eslint-disable-next-line no-negated-condition
  //       if (conn.serverRegion !== undefined) {
  //         serverRegion = conn.serverRegion;
  //       } else {
  //         serverRegion = 'N/A';
  //       }
  //       if (conn.bandwidth !== null && conn.bandwidth !== undefined) {
  //         bandwidthDownload = conn.bandwidth.download;
  //         bandwidthUpload = conn.bandwidth.upload;
  //       }

  //       if (
  //         room.connectionQuality._localStats.resolution &&
  //         room.connectionQuality._localStats.resolution[PP]
  //       ) {
  //         reso_height =
  //           Object.keys(room.connectionQuality._localStats.resolution).length >
  //           0
  //             ? Object.values(
  //                 room.connectionQuality._localStats.resolution[PP]
  //               )[0].height
  //             : 'N/A';
  //         reso_width =
  //           Object.keys(room.connectionQuality._localStats.resolution).length >
  //           0
  //             ? Object.values(
  //                 room.connectionQuality._localStats.resolution[PP]
  //               )[0].width
  //             : 'N/A';
  //       }
  //       if (
  //         room.connectionQuality._localStats.framerate &&
  //         room.connectionQuality._localStats.framerate[PP]
  //       ) {
  //         if (
  //           Object.values(room.connectionQuality._localStats.framerate).keys()
  //             .length > 0
  //         ) {
  //           frame = Object.values(
  //             room.connectionQuality._localStats.framerate[PP]
  //           )[0];
  //         }
  //         console.log(room.connectionQuality._localStats.framerate, PP);
  //       }
  //       if (reso_height !== 'N/A') {
  //         resolution = `${reso_height}*${reso_width}`;
  //       }
  //       if (conn.transport && conn.transport.length > 0) {
  //         local_address = conn.transport[0].localip;
  //         remote_address = conn.transport[0].ip;
  //         transport = conn.transport[0].type;
  //       }
  //     }

  //     return {
  //       resolutionString: resolution,
  //       codecString: `${audioCodec}, ${videoCodec}`,
  //       downloadString: downloadBitrate ?? this.state.downloadString,
  //       uploadString: uploadBitrate ?? this.state.uploadString,
  //       packetLostDownloadString:
  //         downloadPacketLost === undefined
  //           ? this.state.packetLostDownloadString
  //           : `${downloadPacketLost}%`,
  //       packetLostUploadString:
  //         uploadPacketLost === undefined
  //           ? this.state.packetLostUploadString
  //           : `${uploadPacketLost}%`,
  //       serverRegionString: serverRegion,
  //       connectionString: qual,
  //       serverCountString: bridgeCount,
  //       estimatedBandString:
  //         bandwidthDownload ?? this.state.estimatedBandString,
  //       estimatedBandStringUpload:
  //         bandwidthUpload ?? this.state.estimatedBandStringUpload,
  //       frameRate: frame,
  //       remoteAddressString: remote_address,
  //       localAddressString: local_address,
  //       transportString: transport,
  //       connectionToString: this.state.connectionToString,
  //       p2pString: p2p
  //     };
  //   }
  // }

  /**
   * Extracts the resolution and framerate.
   *
   * @param {Object} stats - Connection stats from the library.
   * @private
   * @returns {string}
   */
  _extractResolutionString(stats) {
    const { maxEnabledResolution, resolution } = stats;

    let resolutionString = 'N/A';

    if (resolution && this.props._videoSsrc) {
      const { width, height } = resolution[this.props._videoSsrc] ?? {};

      if (width && height) {
        resolutionString = `${width}x${height}`;

        if (maxEnabledResolution && maxEnabledResolution < 720) {
          const maxEnabledResolutionTitle = this.props.t(
            'connectionindicator.maxEnabledResolution'
          );

          resolutionString += ` (${maxEnabledResolutionTitle} ${maxEnabledResolution}p)`;
        }
      } else resolutionString = this.props._resolution;
    } else resolutionString = this.props._resolution;
    return resolutionString;
  }

  /**
   * Extracts the server name.
   *
   * @param {Object} stats - Connection stats from the library.
   * @private
   * @returns {string}
   */
  _extractServer(stats) {
    return stats.serverRegion ?? this.props._region;
  }

  /**
   * Extracts the audio and video codecs names.
   *
   * @param {Object} stats - Connection stats from the library.
   * @private
   * @returns {string}
   */
  _extractCodecs(stats) {
    const { codec } = stats;
    let codecString = 'N/A';

    if (codec) {
      const audioCodec = codec[this.props._audioSsrc]?.audio;
      const videoCodec = codec[this.props._videoSsrc]?.video;

      if (audioCodec || videoCodec) {
        codecString = [audioCodec, videoCodec].filter(Boolean).join(', ');
      }
    }

    return codecString;
  }

  _extractFramerate(stats) {
    const { framerate } = stats;
    let frameRateString = 'N/A';

    if (framerate) {
      frameRateString = String(framerate[this.props._videoSsrc] ?? 'N/A');
    }
    return frameRateString;
  }
  /**
   * Extracts the connection percentage and sets connection quality.
   *
   * @param {Object} stats - Connection stats from the library.
   * @private
   * @returns {string}
   */
  _extractConnection(stats) {
    const { connectionQuality } = stats;

    if (connectionQuality) {
      const signalLevel = Math.floor(connectionQuality / 33.4);

      return CONNECTION_QUALITY[signalLevel];
    }
  }

  _extractServerCount(stats) {
    return stats.bridgeCount;
  }
  render() {
    const { stats } = this.state;
    const { t, open, onClose } = this.props;
    const { download, upload } = stats.bitrate || {};
    const { download: bandDownload, upload: bandUpload } =
      stats.bandwidth || {};
    const { download: downloadPacket, upload: uploadPacket } =
      stats.packetLoss || {};
    let local_address, remote_address, transport, p2p;
    if (stats.transport && stats.transport.length > 0) {
      local_address = stats.transport[0].localip;
      remote_address = stats.transport[0].ip;
      transport = stats.transport[0].type;
      p2p = stats.transport[0].p2p;
    }
    const informationData = [
      {
        title: t('connectionindicator.status'),
        text: this._extractConnection(stats)
      },
      {
        title: t('connectionindicator.bitrate'),
        text: download ?? 0,
        bitrate: `${upload ?? 0} Kbps`
      },
      {
        title: t('connectionindicator.packetloss'),
        text: `${downloadPacket ?? 0}%`,
        bitrate: `${uploadPacket ?? 0}%`
      },
      { title: t('connectionindicator.p2p'), text: p2p ? 'true' : 'false' },
      {
        title: t('connectionindicator.codecs'),
        text: this._extractCodecs(stats)
      },
      {
        title: t('connectionindicator.resolution'),
        text: this._extractResolutionString(stats)
      },
      {
        title: t('connectionindicator.framerate'),
        text: this._extractFramerate(stats)
      },
      {
        title: t('connectionindicator.bridgeCount'),
        text: this._extractServerCount(stats)
      },
      {
        title: t('connectionindicator.bandwidth'),
        text: bandDownload ?? 0,
        bitrate: bandUpload ?? 0
      },
      {
        title: t('connectionindicator.remoteaddress'),
        text: remote_address ?? 'N/A'
      },
      {
        title: t('connectionindicator.localaddress'),
        text: local_address ?? 'N/A'
      },
      { title: t('connectionindicator.transport'), text: transport ?? 'N/A' },
      {
        title: t('connectionindicator.connectedTo'),
        text: this._extractServer(stats)
      }
    ];

    return (
      <React.Fragment>
        <Dialog open={open} onClose={onClose} className="dialogView">
          <DialogTitle>
            <Box className="menuTitle" onClick={onClose}>
              <Box>System information:</Box>

              <CloseIcon />
            </Box>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              border: '1px solid #BBBBBB',
              display: 'flex',
              flexDirection: 'column'
            }}>
            <Box sx={{ padding: '16px 16px 0px 16px' }}>
              {informationData.map((stock, index) => (
                <Box key={index}>
                  <Box sx={{ columnCount: 2, marginBottom: '12px' }}>
                    <Box className="informationTitle">{stock.title}</Box>
                    <Box sx={{ display: 'flex' }}>
                      <Box className="informationText">{stock.text}</Box>
                      {stock.bitrate ? (
                        <>
                          <DownArrowIcon
                            width={20}
                            height={20}
                            style={{ marginLeft: '4px' }}
                          />
                          <Box className="informationText">{stock.bitrate}</Box>
                          <UpArrowIcon
                            width={20}
                            height={20}
                            style={{ marginLeft: '4px' }}
                          />
                        </>
                      ) : null}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>

            <Box className="divider" />
            <Box className="floatButton">
              <ListButton gray onClick={onClose}>
                Close
              </ListButton>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
function _mapStateToProps(state) {
  const tracks = state['features/base/tracks'];
  const conference = state['features/base/conference'].conference;
  const participant = getLocalParticipant(state);
  const audioTrack = getTrackByMediaTypeAndParticipant(
    tracks,
    MEDIA_TYPE.AUDIO,
    participant?.id
  );
  let videoTrack = getTrackByMediaTypeAndParticipant(
    tracks,
    MEDIA_TYPE.VIDEO,
    participant?.id
  );
  return {
    _conference: conference,
    _participantID: participant?.id,
    _resolution: videoTrack?.jitsiTrack?.resolution,
    _audioSsrc: audioTrack
      ? conference?.getSsrcByTrack(audioTrack.jitsiTrack)
      : undefined,
    _region: participant?.region,
    _videoSsrc: videoTrack
      ? conference?.getSsrcByTrack(videoTrack.jitsiTrack)
      : undefined
  };
}
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(SystemInformation)))
);

SystemInformation.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  t: PropTypes.func,
  _conference: PropTypes.object,
  _resolution: PropTypes.any,
  _participantID: PropTypes.string,
  _region: PropTypes.string,
  _audioSsrc: PropTypes.any,
  _videoSsrc: PropTypes.any
};
